/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Stack } from '@fluentui/react/lib/Stack';
import * as React from 'react';
import { noop } from 'src/core/utils/base';
import { transformLabels } from 'src/luis/modules/labeling/utils/transformLabels';
import { Utterance } from 'src/luis/projects/utterances/types/Utterance';
import { Labeler } from 'src/modules/labeling/components/Labeler';

export type BatchTestUtteranceRowProps = {
    /**
     * Utterance tokenized text as segments
     */
    utterance: Utterance;

    /**
     * Wether the utterance is RTL or not.
     */
    isRTL: boolean;
};

export const BatchTestUtteranceRow = (props: BatchTestUtteranceRowProps) => {
    const { utterance, isRTL } = props;

    const labels = React.useMemo(
        () => transformLabels({ tokenizedText: utterance.tokenizedText, userLabels: [], predictions: utterance.predictedEntities }),
        [utterance]
    );

    return (
        <Stack verticalAlign="center" verticalFill>
            <Labeler
                config={{ disabled: true, isRTL }}
                linesTokens={[utterance.tokenizedText]}
                text={utterance.text}
                labels={labels.labels}
                conflicts={labels.conflicts}
                onSelect={noop}
                onLabelResize={noop}
                onShapeClick={noop}
                onTokenHover={noop}
                onTokenHoverExit={noop}
            />
        </Stack>
    );
};
